import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

const checkBoxClasses = tv({
  slots: {
    root: [
      "flex size-5 items-center justify-center rounded-md outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-main data- border data-[checked]:border-primary-main data-[checked]:bg-primary-main  data-[unchecked]:border-gray-300 flex-shrink-0",
    ],
    label: [
      "inline-flex items-center gap-2 text-base text-gray-900 cursor-pointer select-none",
    ],
    indicator: "flex text-gray-50 data-[unchecked]:hidden",
    icon: "size-5",
  },
  variants: {
    colSpan: {
      1: {
        root: ["col-span-1"],
      },
      2: {
        root: ["col-span-1 sm:col-span-2"],
      },
      3: {
        root: ["col-span-1 sm:col-span-3"],
      },
      4: {
        root: ["col-span-1 sm:col-span-4"],
      },
      5: {
        root: ["col-span-1 sm:col-span-5"],
      },
      6: {
        root: ["col-span-1 sm:col-span-6"],
      },
    },
  },
});

export const {
  root: checkboxRootClasses,
  label: checkboxLabelClasses,
  indicator: checkboxIndicatorClasses,
  icon: checkboxIconClasses,
} = checkBoxClasses();

export type CheckBoxVariant = VariantProps<typeof checkBoxClasses>;
